<div class="tw-flex tw-justify-between tw-items-center tw-border tw-border-solid px-3 py-2 tw-rounded tw-leading-none">
  <div class="tw-flex tw-gap-2 tw-items-center tw-h-12">
    @if (icon) {
      <sb-icon [icon]="icon"></sb-icon>
    }
    <span [ngClass]="{'tw-text-gray-700': !display?.name}">
    {{ display?.name ?? emptyString }}
    </span>
  </div>
  @if (!hideAll) {
    <div class="tw-flex tw-gap-1">
      <button class="btn btn-hover-primary" type="button" (click)="selectClicked.emit(true)">
        <sb-icon icon="list"></sb-icon>
      </button>
      @if (!hideCreate) {
        <div class="vertical-spacer !tw-h-11"></div>
        <button class="btn btn-hover-primary" type="button" (click)="createClicked.emit(true)">
          <sb-icon icon="plus"></sb-icon>
        </button>
      }
      @if (display) {
        <div class="vertical-spacer !tw-h-11"></div>
        <button class="btn btn-danger" type="button" (click)="deleteClicked.emit(true)">
          <sb-icon icon="trash"></sb-icon>
        </button>
      }
    </div>
  }
</div>
